<template>
	<el-container class="wrap-80">
		<BreadCrumb></BreadCrumb>

		<BaseInfo @successInvoice="getConsumerOrderInvoice" :invoiceInfo="invoiceInfo" :orderAddress="orderAddress" :orderBasic="orderBasic" :orderDetails="orderDetails" @successPay="successPay"></BaseInfo>

		<el-card class="cartbox" shadow="never">
			<el-row style="width: 100%" v-if="orderAddress !== null">
				<el-col :span="8">
					<AddressInfo :orderAddress="orderAddress" :orderBasic="orderBasic" @addressUpdated="addressUpdated"></AddressInfo>
				</el-col>
				<el-col :span="16">
					<GoodsList :orderDetails="orderDetails" :orderBasic="orderBasic" :orderAddress="orderAddress" @downloadSuccess="downloadSuccess"></GoodsList>
				</el-col>
			</el-row>
			<el-row style="width: 100%" v-else>
				<el-col :span="24">
					<GoodsList :orderDetails="orderDetails" :orderBasic="orderBasic" :orderAddress="orderAddress" @downloadSuccess="downloadSuccess"></GoodsList>
				</el-col>
			</el-row>
		</el-card>
	</el-container>
</template>

<script>
import Y from '@/utils/Y';
import { getConsumerOrderInfo, getConsumerOrderInvoice } from '@/api/order/order';
import BaseInfo from './components/BaseInfo.vue';
import PayType from './components/PayType.vue';
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import GoodsList from './components/GoodsInfo.vue';
import AddressInfo from './components/AddressInfo.vue';
import { mapActions } from 'vuex';

export default {
	data() {
		return {
			loading: false,
			orderAddress: {},
			orderBasic: {},
			orderDetails: [],
			invoiceInfo: {}
		};
	},
	components: {
		BaseInfo,
		PayType,
		BreadCrumb,
		GoodsList,
		AddressInfo
	},
	methods: {
		//获取发票信息
		getConsumerOrderInvoice() {
			getConsumerOrderInvoice(this.$route.query.orderId).then(res => {
				if (res.code == 200) {
					if (res.data !== null) {
						this.invoiceInfo = res.data;
					}
				}
			});
		},

		successPay() {
			this.getConsumerOrderInfo();
		},

		downloadSuccess() {
			this.getConsumerOrderInfo();
		},

		//获取订单详情
		getConsumerOrderInfo() {
			this.loading = true;
			getConsumerOrderInfo(this.$route.query.orderId)
				.then(res => {
					const { orderAddress, orderBasic, orderDetails } = res.data;
					this.orderAddress = orderAddress;
					this.orderBasic = orderBasic;
					let orderDetailsTemp = orderDetails;
					//orderDetailsTemp 是个list 根据isDigit 分组
					// orderDetailsTemp = orderDetailsTemp.reduce((prev, cur) => {
					// 	if (prev[cur.isDigit]) {
					// 		prev[cur.isDigit].push(cur);
					// 	} else {
					// 		prev[cur.isDigit] = [cur];
					// 	}
					// 	return prev;
					// }, {});
					// orderDetailsTemp = [
					// 	{ isDigit: 0, items: orderDetailsTemp[0] || [] },
					// 	{ isDigit: 1, items: orderDetailsTemp[1] || [] },
					// 	{ isDigit: 2, items: orderDetailsTemp[2] || [] }
					// ];
					// //if orderDetailsTemp is empty,删除空数组
					// orderDetailsTemp = orderDetailsTemp.filter(item => item.items.length > 0);
					// console.log('orderDetailsTemp',orderDetailsTemp);

					//orderDetails 根据isDigit 排序
					orderDetails.sort((a, b) => a.isDigit - b.isDigit);
					this.orderDetails = orderDetails;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					Y.msg.error(err.message || '获取订单详情失败');
				});
		},

		addressUpdated() {
			this.getConsumerOrderInfo();
		},

		...mapActions('Settings', ['setBreadcrumbList', 'setLoginShow'])
	},

	// 加载完执行
	created() {
		this.getConsumerOrderInfo();
		this.getConsumerOrderInvoice();
		//包含VIP则是会员订单，否则是图书订单
		const listPath = this.$route.query.orderId.indexOf('VIP') >= 0 ? '/UserCenter/VIPOrder' : '/UserCenter/BookOrder';
		const breadcrumbs = [
			{
				path: '/Home',
				name: '首页'
			},
			{
				path: listPath,
				name: '我的订单'
			},
			{
				name: '订单详情'
			}
		];
		this.setBreadcrumbList(breadcrumbs);
		//如果isPaySuccess为true,则提示用户支付成功
		// if (this.$route.query.isPaySuccess == 'true') {
		// 	if (this.$route.query.orderId.indexOf('VIP') >= 0) {
		// 		this.$confirm('VIP会员订单已完成，需要重新登录才可更新会员状态!', '提示', {
		// 			confirmButtonText: '重新登录',
		// 			cancelButtonText: '取消',
		// 			type: 'warning'
		// 		})
		// 			.then(() => {
		// 				this.setLoginShow(true);
		// 			})
		// 			.catch(() => {
						
		// 			});
		// 	}
		// }
	}
};
</script>

<style lang="less" scoped>
.cartbox {
	margin-bottom: 30px;
	// background-color: #ffffff;
	// box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	// border-radius: 15px;
	// width: 100%;
}

.cart-head {
	margin: 10px 0 15px 0;
	padding: 0 20px;
	label + button {
		margin-left: 20px;
	}
}
/deep/ .el-checkbox__inner {
	width: 18px;
	height: 18px;
	border: none;
	box-shadow: inset 0 0 4px rgba(20, 116, 226, 0.5);
}
/deep/ .el-checkbox {
	margin-right: 25px;
	color: #333333;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
	background-color: #1474e2;
	border-color: #1474e2;
	border-radius: 3px;
}
/deep/.el-checkbox__inner::after {
	border: 2px solid #fff;
	left: 6px;
	top: 3px;
	border-left: 0;
	border-top: 0;
}
/deep/ .el-checkbox {
	margin-right: 5px;
}
/deep/ .el-button {
	//background-color: #f3f4f6;
	//border: 1px solid #b3d1ff;
	//color: #333333;
	//font-size: 14px;
}
.card-item {
	margin-bottom: 10px;
	padding: 10px 0;
	color: #888888;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 10px;
	.goodinfo {
		flex: 4 1;
		margin-right: 20px;
	}
	h4 {
		margin: 0 0 10px 0;
		color: #333333;
		font-weight: 400;
	}
	.card-date {
		font-size: 12px;
	}
	span + span {
		margin-left: 30px;
	}
	b {
		margin-left: 10px;
	}
	.pricebox {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1 1;
		padding-right: 20px;
		font-size: 18px;
		.price {
			display: flex;
			align-items: baseline;
			color: #1474e2;
		}
		sub {
			margin-left: 8px;
			font-size: 10px;
			color: #ec2b2d;
		}
	}
	.actbox {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
		a {
			margin-left: 20px;
			color: #888888;
			text-decoration: none;
		}
		a:hover {
			color: #1474e2;
		}
	}
}
/deep/ .el-card__body {
	display: flex;
	justify-content: space-between;
}
/deep/ .el-link.is-underline:hover:after {
	border-bottom: none;
}
.cart-bottom {
	position: fixed;
	background-color: #ffffff;
	width: 100%;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 10;
	padding: 25px 6%;
	box-sizing: border-box;
	color: #333333;
	font-size: 14px;
	box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.05);
	border-radius: 12px 12px 0px 0px;
	b {
		font-size: 20px;
		color: #ec2b2d;
	}
	.cart-leftbox {
		span {
			margin-left: 30px;
		}
	}
	.pricebox {
		margin-right: 20px;
		.price {
			margin-bottom: 5px;
		}
	}
}
.emptybox {
	text-align: center;
	padding-bottom: 50px;
	background: #fff;
}
.wrap-80 {
	min-height: calc(100vh - 400px);
}
//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
	.wrap-80 {
		width: 96%;
	}
	.cart-bottom {
		padding: 25px 3%;
	}
}
</style>
